// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_slU","cls2":"SimplePaperPodcast-cls2_ujL SimplePaperPodcast-cls1_slU"};